import { useQueryClient } from "@tanstack/react-query";

import { View, ViewQueryParams } from "@/types";

export const useSetView = () => {
  const queryClient = useQueryClient();

  return ({
    updatedView,
    viewQueryParams,
  }: {
    updatedView: View;
    viewQueryParams: ViewQueryParams;
  }) => {
    queryClient.setQueryData(
      ["views", viewQueryParams],
      (cachedViews: View[]) => {
        return cachedViews.map((view) => {
          if (view.id === updatedView.id) {
            return updatedView;
          }
          return view;
        });
      },
    );
  };
};
